import { browserBridge } from "./browser";
import type { DesktopBridge } from "./types";

export { DesktopGitError, normalizeDesktopGitError } from "./git";
export { DesktopFileSearchError, normalizeDesktopFileSearchError } from "./fileSearch";
export { DesktopGitHubError, normalizeDesktopGitHubError } from "./github";
export { DesktopFilesystemError, normalizeDesktopFilesystemError } from "./filesystem";
export { DesktopAuthSessionError, normalizeDesktopAuthSessionError } from "./authSession";
export {
  DesktopTerminalError,
  normalizeDesktopTerminalError,
  type DesktopTerminalHost,
} from "./nativeTerminal";
export {
  desktopSshErrorEndsSession,
  DesktopSshFileError,
  normalizeDesktopSshFileError,
} from "./sshFiles";
export {
  DesktopExternalOpenError,
  normalizeExternalHttpUrl,
  openExternalBrowserWindow,
  openExternalWith,
  type DesktopExternalOpenErrorCode,
} from "./external";

export type {
  DesktopBridge,
  DesktopAuthSessionErrorCode,
  DesktopAuthSessionErrorPayload,
  DesktopAuthSessionHost,
  DesktopAuthSessionLoadResult,
  DesktopGitChangedFile,
  DesktopGitDiffResult,
  DesktopGitDiffScope,
  DesktopGitErrorCode,
  DesktopGitErrorPayload,
  DesktopGitFileState,
  DesktopGitHost,
  DesktopGitStatusResult,
  DesktopFileSearchErrorCode,
  DesktopFileSearchErrorPayload,
  DesktopFileSearchHost,
  DesktopFileSearchMatch,
  DesktopFileSearchResult,
  DesktopGitHubErrorCode,
  DesktopGitHubErrorPayload,
  DesktopGitHubHost,
  DesktopGitHubPullRequestDiffResult,
  DesktopGitHubPullRequestFile,
  DesktopGitHubPullRequestListResult,
  DesktopGitHubPullRequestResult,
  DesktopGitHubPullRequestSummary,
  DesktopGitHubRepository,
  DesktopFilesystemEntry,
  DesktopFilesystemEntryKind,
  DesktopFilesystemErrorCode,
  DesktopFilesystemErrorPayload,
  DesktopFilesystemHost,
  DesktopFilesystemListDirectoryInput,
  DesktopFilesystemListDirectoryResult,
  DesktopFilesystemReadFileBytesInput,
  DesktopFilesystemReadFileBytesResult,
  DesktopFilesystemReadTextFileInput,
  DesktopFilesystemReadTextFileResult,
  DesktopTerminalAttachResult,
  DesktopTerminalErrorCode,
  DesktopTerminalErrorPayload,
  DesktopTerminalEvent,
  DesktopTerminalListedSession,
  DesktopTerminalListInput,
  DesktopTerminalListResult,
  DesktopTerminalOperation,
  DesktopTerminalResizeInput,
  DesktopTerminalSessionId,
  DesktopTerminalSessionRef,
  DesktopTerminalSpawnInput,
  DesktopTerminalSpawnResult,
  DesktopTerminalWriteInput,
  DesktopSshDiscoveredHost,
  DesktopSshDiscoverHostsInput,
  DesktopSshFileConnectInput,
  DesktopSshFileEntry,
  DesktopSshFileEntryKind,
  DesktopSshFileErrorCode,
  DesktopSshFileErrorPayload,
  DesktopSshFileHost,
  DesktopSshFileScope,
  DesktopSshHostDiscovery,
  DesktopSshFileSession,
  DesktopSshFileSessionRef,
  DesktopSshListDirectoryInput,
  DesktopSshListDirectoryResult,
  DesktopSshReadTextFileInput,
  DesktopSshReadTextFileResult,
} from "./types";

export type { DesktopWorkspaceRootGrant } from "@papersflow/contracts/desktop-workspace";

export const desktopBridge: DesktopBridge =
  "__TAURI_INTERNALS__" in globalThis ? (await import("./tauri")).tauriBridge : browserBridge;
